/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Pwf_New_Status_ForInputs */

const en_pwf_new_status_for = /** @type {(inputs: Pwf_New_Status_ForInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`New status for ${i?.name}`)
};

const de_pwf_new_status_for = /** @type {(inputs: Pwf_New_Status_ForInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Neuer Status für ${i?.name}`)
};

/**
* | output |
* | --- |
* | "New status for {name}" |
*
* @param {Pwf_New_Status_ForInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const pwf_new_status_for = /** @type {((inputs: Pwf_New_Status_ForInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pwf_New_Status_ForInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pwf_new_status_for(inputs)
	return en_pwf_new_status_for(inputs)
});